import apiClient from './api';
import { t } from 'i18n';

/**
 * Countdown deals -- every call returns { success: true, data } or
 * { success: false, error } (never throws). The backend's own `detail`
 * is preferred (it is already specific).
 */
async function call(promise) {
  try {
    const response = await promise;
    return { success: true, data: response.data };
  } catch (error) {
    const detail = error.response?.data?.detail;
    return {
      success: false,
      status: error.response?.status,
      error: typeof detail === 'string' ? detail : t('dealsAdmin.errors.generic'),
    };
  }
}

export const DealsService = {
  getActive: () => call(apiClient.get('/deals/active')),
};

export const VendorDealsService = {
  list: () => call(apiClient.get('/vendor/deals')),
  eligibleProducts: () => call(apiClient.get('/vendor/deals/eligible-products')),
  create: (body) => call(apiClient.post('/vendor/deals', body)),
  update: (id, body) => call(apiClient.put(`/vendor/deals/${id}`, body)),
  cancel: (id, reason) => call(apiClient.post(`/vendor/deals/${id}/cancel`, { reason: reason || null })),
};

export const AdminDealsService = {
  list: (params = {}) => call(apiClient.get('/admin/deals', { params })),
  cancel: (id, reason) => call(apiClient.post(`/admin/deals/${id}/cancel`, { reason })),
  getLimit: (storeId) => call(apiClient.get(`/admin/deals/stores/${storeId}/limit`)),
  setLimit: (storeId, limit, reason) => call(apiClient.put(`/admin/deals/stores/${storeId}/limit`, { limit, reason })),
  house: () => call(apiClient.get('/admin/deals/house')),
  createHouse: (body) => call(apiClient.post('/admin/deals/house', body)),
};

/** Milliseconds left until an ISO timestamp (never negative). */
export function msUntil(iso) {
  const end = Date.parse(iso);
  return Number.isFinite(end) ? Math.max(0, end - Date.now()) : 0;
}
